<div class="container-fluid">

    <div *ngIf="isReadyIsalData; else loading" class="col-md-12">

        <table width="100%">
            <tr>
            <td width="90%">
                <p-table #isalTable [columns]="isalCols" [scrollable]="true" [value]="isalDataDisplayed" scrollHeight="50vh" sortMode="multiple">
                    <ng-template pTemplate="caption">
                        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                        <input (input)="isalTable.filterGlobal($event.target.value, 'contains')" pInputText
                                placeholder="Search" size="30" style="width:auto; height: 30px; margin-top: 5px;" type="text" [(ngModel)]="searchBoxText">
                        <button (click)="loadIsalData()" style="margin-left: 15px; margin-right: 15px; margin-top: -5px;" class="btn btn-primary" type="button">Reload ISAL Data</button>
                        <button (click)="createISALActivityPlan(irrigateTemplate)" style="margin-top: -5px; margin-right: 15px;" [disabled]="isalDataSelected.length < 1 || !canUserViewIsal" class="btn btn-primary" type="button">Create Irrigation Plan</button>
                        <label style="font-size: 14px">Selected: {{isalDataSelected.length}} of {{isalDataDisplayed.length}}</label>
                    </ng-template>

                    <ng-template let-columns pTemplate="header">
                        <tr style="height: 45px;">
                            <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                                <div *ngIf="col.field == 'checked'" (click)="toggleSelectAll()" style="padding-left: 12px; font-size: 20px;">▣</div>
                                {{col.header}}
                                <!-- <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon> -->
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                        <tr style="height: 40px;" >
                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                <div >
                                    <p-checkbox [(ngModel)]="rowData.checked" binary="true" id="{{rowData.euid}}" name="{{rowData.euid}}" [ngModelOptions]="{standalone: true}" (ngModelChange)="isalCheckedChanged()" ></p-checkbox>
                                </div>
                            </td>

                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.euid }}
                            </td>

                            <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.storageContainer }}
                            </td>

                            <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.cropType }}
                            </td>

                            <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.moisture }}
                            </td>

                            <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.alarmCount }}
                            </td>

                            <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.lastWaterPlanElapsedDays }}
                            </td>

                            <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.plantingDateOffset }}
                            </td>

                            <td [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.activityPhase }}
                            </td>

                            <td [ngStyle]="{'width': columns[9].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.commentName }}
                            </td>

                            <td [ngStyle]="{'width': columns[10].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.requestDescription }}
                            </td>

                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        Either no results returned from ISAL or no filtered results
                    </ng-template>
                </p-table>
            </td>

            <td width="10%" style="border: 1px dotted lightgray; background-color: white; padding: 5px;  max-width: 300px;">
                <div style="height: 54vh; overflow-y: scroll; overflow-x: auto; white-space: nowrap;">
                    <label>
                        FILTERS
                    </label>
                    <div>
                        <p-listbox [options]="commentNames" [(ngModel)]="selectedCommentNames" [checkbox]="true" [multiple]="true" [style]="{'font-size':'14px'}" [listStyle]="{'max-height':'200px'}" (onChange)="updateDisplayedISALDataOnSearchCriteria()" >
                            <ng-template pTemplate="header">
                                <b>Comments</b>
                            </ng-template>
                        </p-listbox>
                    </div>
                    <div style="margin-top: 5px;" >
                        <p-listbox [options]="activityPhases" [(ngModel)]="selectedActivityPhases" [checkbox]="true" [multiple]="true" [style]="{'font-size':'14px'}" [listStyle]="{'max-height':'200px'}" (onChange)="updateDisplayedISALDataOnSearchCriteria()" >
                            <ng-template pTemplate="header">
                                <b>Activitity Phases</b>
                            </ng-template>
                        </p-listbox>
                    </div>
                    <div style="margin-top: 5px;" >
                        <p-listbox [options]="storageLocationNames" [(ngModel)]="selectedStorageLocationNames" [checkbox]="true" [multiple]="true" [style]="{'font-size':'14px'}" [listStyle]="{'max-height':'200px'}" (onChange)="updateDisplayedISALDataOnSearchCriteria()" >
                            <ng-template pTemplate="header">
                                <b>Storage Locations</b>
                            </ng-template>
                        </p-listbox>
                    </div>
                    <div style="margin-top: 5px;" >
                        <p-listbox [options]="cropTypeNames" [(ngModel)]="selectedCropTypeNames" [checkbox]="true" [multiple]="true" [style]="{'font-size':'14px'}" [listStyle]="{'max-height':'200px'}" (onChange)="updateDisplayedISALDataOnSearchCriteria()" >
                            <ng-template pTemplate="header">
                                <b>Crop Types</b>
                            </ng-template>
                        </p-listbox>
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                        <input type="number" style="margin-top: 5px; width: 50px;" [(ngModel)]="plantingDateLow" (ngModelChange)="updateDisplayedISALDataOnSearchCriteria()" name="plantingLow" />
                        <label style="font-size: 16px; margin-top: 9px;"> &lt; Planting &lt; </label>
                        <input type="number" style="margin-top: 5px; width: 50px;" [(ngModel)]="plantingDateHigh" (ngModelChange)="updateDisplayedISALDataOnSearchCriteria()" name="plantingHigh" />
                    </div>
                    <div style="display: flex; justify-content: space-between;">
                        <input type="number" style="margin-top: 5px; width: 50px;" [(ngModel)]="transPlantDateLow" (ngModelChange)="updateDisplayedISALDataOnSearchCriteria()" name="transPlantDateLow" />
                        <label style="font-size: 16px; margin-top: 9px;"> &lt; Transplant &lt; </label>
                        <input type="number" style="margin-top: 5px; width: 50px;" [(ngModel)]="transPlantDateHigh" (ngModelChange)="updateDisplayedISALDataOnSearchCriteria()" name="transPlantDateHigh" />
                    </div>
                </div>
            </td>

            </tr>
        </table>

    </div>
</div>


<ng-template #loading>
    <div class="col-xs-4 col-lg-3" style="margin-top: 20px;">
        <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin-right: 10px;"></i>
        <span>Loading...</span>
    </div>
</ng-template>


<ng-template #irrigateTemplate>
    <div class="modal-content irrigate-modal">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">Create ISAL Irrigate Plan</h5>
            <button
                (click)="irrigateModalRef.hide()"
                class="ms-auto fas fa-times" type="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
  
        <div class="modal-body">
            <div style="margin-bottom: 20px; display: flex; gap: 20px;">
                <div class="form-group" style="width: 260px;">
                    <label for="starttime">Start Time (optional)</label>
                    <input type="datetime-local" id="starttime" name="starttime" class="form-control" [(ngModel)]="isalIrrigatePlan.startOn" style="border-color: darkgray;" required>
                </div>
                <div class="form-group" style="width: 180px;">
                    <label for="duration">Watering Duration (sec)</label>
                    <input type="text" id="duration" name="duration" class="form-control" [(ngModel)]="isalIrrigatePlan.duration" style="border-color: darkgray;" required>
                </div>
            </div>

            <div style="margin-bottom: 20px; display: flex; gap: 20px;">
                <div class="form-group" style="width: 260px;">
                    <label for="waterrig">Select Watering Rig (Optional)</label>
                    <select name="irrigationRig" [(ngModel)]="isalIrrigatePlan.wateringRig" style="height:35px; width: 260px; border-color: darkgray;">
                        <option [value]="i" *ngFor="let i of irrigationRigOptions">{{i}}</option>
                    </select>    
                </div>
                <div class="form-group" style="width: 180px;">
                    <label for="waterrig">Release (Optional)</label>
                    <select name="irrigationRig" [(ngModel)]="isalIrrigatePlan.releaseOption" style="height:35px; width: 180px; border-color: darkgray;">
                        <option [value]="i" *ngFor="let i of irrigationExecutionOptions">{{i}}</option>
                    </select>    
                </div>
            </div>

            <div style="margin-bottom: 20px; display: flex; gap: 20px;">
                <div class="form-group" style="width: 460px;">
                    <label for="description">Description</label>
                    <input type="text" size="50" id="description" name="description" class="form-control" [(ngModel)]="isalIrrigatePlan.description" style="border-color: darkgray;" required>
                </div>
            </div> 

            <br>
            <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
            <button (click)="sendISALActivityPlan()" class="btn btn-success pull-right" >Send to ISAL</button>
            <button (click)="irrigateModalRef.hide()" class="btn btn-basic pull-right" style="margin-right: 10px;" type="button">Cancel</button>

        </div>
    </div>
</ng-template>

